import useSlugExtractor from "@hooks/useSlugExtractor"

import { ObjectsView } from "@organisms"

import {
    getCategoryTabId,
    getCategoryTitle,
} from "@pages/Settings/SettingsCatalogs/SettingsCatalogsItemList/SettingsCatalogsItemList.utils"

import { CATALOG_ENDPOINTS } from "@endpoints/catalogs"

import { CatalogItemObjectsViewTabsProps } from "./views/CatalogItemTableView/CatalogItemTableView.types"

export const CatalogItemObjectsViewTabs = (props: CatalogItemObjectsViewTabsProps) => {
    const { catalogId, brandParam, categories } = props

    const [listEndpoint, countEndpoint] = useSlugExtractor([CATALOG_ENDPOINTS.ITEMS, CATALOG_ENDPOINTS.ITEMS_COUNT])

    // Catalog and brand scope every tab's listing; the brand param carries a real id or the
    // null-scope sentinel for the brandless page, and category tabs add their own filter on top.
    const scopeKwargs: [string, string][] = [
        ["catalog", String(catalogId)],
        ["brand", brandParam],
    ]

    return (
        <ObjectsView.Tabs>
            <ObjectsView.Tab
                id="all"
                title="All"
                phase="active"
                endpointKwargs={scopeKwargs}
                isDefaultActiveTabForPhase={true}
                listEndpoint={listEndpoint}
                countEndpoint={countEndpoint}
            />
            {categories.map((category) => (
                <ObjectsView.Tab
                    key={category.id}
                    id={getCategoryTabId(category)}
                    title={getCategoryTitle(category)}
                    phase="active"
                    endpointKwargs={[...scopeKwargs, ["category", String(category.id)]]}
                    isDefaultActiveTabForPhase={false}
                    listEndpoint={listEndpoint}
                    countEndpoint={countEndpoint}
                />
            ))}
        </ObjectsView.Tabs>
    )
}
